import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AppFormInput } from 'client/ui-building-blocks'
import { ApiErrors } from 'client/utils'
import { EMAIL_MAX_LENGTH } from 'cat-shared/utils'
import { isEmailValid } from 'cat-shared/validation'

type Props = {
  getRecoveryLinkSuccess: boolean
  apiErrors: ApiErrors
  isLoading: boolean
}

const EmailInput = ({ getRecoveryLinkSuccess, apiErrors, isLoading }: Props) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error =
    errors?.email?.message ||
    (apiErrors?.email ? t(`apiValidationErrors.${apiErrors.email}`) : '')

  const isDisabled = isLoading || getRecoveryLinkSuccess

  return (
    <Controller
      control={control}
      name="email"
      rules={{
        required: t('common.validation.required'),
        validate: value => isEmailValid(value) || t('common.validation.invalid'),
      }}
      render={({ field: { value, onChange } }) => {
        return (
          <AppFormInput
            value={value}
            onChange={onChange}
            label={t('common.email.label')}
            placeholder={t('common.email.placeholder')}
            maxLength={EMAIL_MAX_LENGTH}
            disabled={isDisabled}
            error={String(error || '')}
          />
        )
      }}
    />
  )
}

export default EmailInput
